export const AppConstants = {
    toastAutoClose: 3000
};